// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pg-0";